import { ICollectionReference } from "../database-cast/IDatabase";
import { DbObjectBase } from "./db-object-base";




export class DbCustomerLotteryLab extends DbObjectBase<any> {

  constructor(labId: string, collection: ICollectionReference) {
    super(labId, collection);

  }



}
